// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__2OI_s","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__3d9k2"};